var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeActivate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.2501C9.5 8.0751 8.825 8.7501 8 8.7501C7.175 8.7501 6.5 8.0751 6.5 7.2501C6.5 6.4251 7.175 5.7501 8 5.7501C8.825 5.7501 9.5 6.4251 9.5 7.2501ZM11 7.2501H15.5C15.5 4.4751 14 2.0751 11.75 0.725098L9.5 4.6251C10.4 5.1501 11 6.1251 11 7.2501ZM8 10.2501C7.475 10.2501 6.95 10.1001 6.5 9.8001C5.6 11.3751 4.55 13.1001 4.25 13.7001C5.375 14.3751 6.65 14.6751 8 14.6751C9.35 14.6751 10.625 14.3001 11.75 13.7001L9.5 9.8001C9.05 10.1001 8.525 10.2501 8 10.2501ZM6.5 4.7001C5.6 3.1251 4.55 1.3251 4.25 0.725098C2 2.0001 0.5 4.4751 0.5 7.2501H5C5 6.1251 5.6 5.1501 6.5 4.7001Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeActivate);
export default __webpack_public_path__ + "static/media/deActivate.63dc6f32fbf6290766b6a3b10a3bde16.svg";
export { ForwardRef as ReactComponent };